var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-main-container"},[_c('main-header',{attrs:{"show-logo":true,"is-active":false}}),(_vm.isInitialRoute)?_c('div',{staticClass:"top-bar"}):_vm._e(),_c('div',{staticClass:"dashboard-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }